import React, { useEffect } from "react";
import "@/App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import AccessibilityWidget from "@/components/AccessibilityWidget";
import MobileCallBar from "@/components/MobileCallBar";
import NewsletterPopup from "@/components/NewsletterPopup";

import Home from "@/pages/Home";
import Collection from "@/pages/Collection";
import ProductDetail from "@/pages/ProductDetail";
import BrandPage from "@/pages/BrandPage";
import Locations from "@/pages/Locations";
import StoreDetail from "@/pages/StoreDetail";
import CityLanding from "@/pages/CityLanding";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Financing from "@/pages/Financing";
import Reviews from "@/pages/Reviews";
import Videos from "@/pages/Videos";
import Promotions from "@/pages/Promotions";
import AccessibilityStatement from "@/pages/AccessibilityStatement";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function NotFound() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-24 text-center">
      <p className="text-6xl font-bold text-[#D0021B]">404</p>
      <h1 className="mt-4 text-2xl font-bold uppercase text-neutral-900">Page Not Found</h1>
      <p className="mt-2 text-neutral-600">The page you're looking for doesn't exist.</p>
      <Link to="/" className="mt-6 inline-block rounded-full bg-[#D0021B] px-8 py-3 text-sm font-bold uppercase tracking-wide text-white hover:bg-[#a80016]">
        Back Home
      </Link>
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <div className="App">
          <a href="#main-content" className="skip-link">Skip to main content</a>
          <ScrollToTop />
          <Header />
          <main id="main-content" tabIndex={-1}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/mattresses" element={<Collection category="mattresses" />} />
              <Route path="/adjustable-bases" element={<Collection category="adjustable-bases" />} />
              <Route path="/foundations" element={<Collection category="foundations" />} />
              <Route path="/products/:slug" element={<ProductDetail />} />
              <Route path="/brands/:slug" element={<BrandPage />} />
              <Route path="/locations" element={<Locations />} />
              <Route path="/locations/fort-lauderdale" element={<StoreDetail />} />
              <Route path="/mattress-store/:slug" element={<CityLanding />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/financing" element={<Financing />} />
              <Route path="/videos" element={<Videos />} />
              <Route path="/promotions" element={<Promotions />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/accessibility-statement" element={<AccessibilityStatement />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
          <div className="h-16 lg:hidden" aria-hidden="true" />
          <AccessibilityWidget />
          <MobileCallBar />
          <NewsletterPopup />
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
